import { useSelector } from '@xstate/react'
import { Alert } from 'components'
import { useUsersService } from 'providers'
import { useEffect, useState } from 'react'
import { AnyUserData } from 'types'

export const GlobalUpdateUserNotification = (props: any) => {
  const usersService = useUsersService()
  const updatedUser = useSelector(
    // @ts-ignore
    usersService,
    (state: any) => {
      const id = state.context.lastUserEvent.data.id
      return state.matches('updatingUser') && state.context.users[id]
    }
  )
  const [user, setUser] = useState<Partial<AnyUserData> | undefined>(undefined)
  useEffect(() => {
    if (updatedUser) {
      setUser(updatedUser)
    }
  }, [updatedUser, setUser])

  return user ? (
    <Alert
      key={user.id}
      variant="info"
      onClose={() => setUser(undefined)}
      open
      {...props}
    >
      <strong>
        {user.forename} {user.surname}{' '}
      </strong>
      updated successfully!
    </Alert>
  ) : null
}

export const GlobalCreateUserNotification = (props: any) => {
  const createdUser = useSelector(
    // @ts-ignore
    useUsersService(),
    (state: any) => {
      const id = state.context.lastUserEvent.data.id
      return state.matches('creatingUser') && state.context.users[id]
    }
  )
  const [user, setUser] = useState<Partial<AnyUserData> | undefined>(undefined)
  useEffect(() => {
    if (createdUser) {
      setUser(createdUser)
    }
  }, [createdUser, setUser])
  return user ? (
    <Alert variant="info" onClose={() => setUser(undefined)} open {...props}>
      {user.userType === 'Teacher' ? 'Teacher' : 'Student'}{' '}
      <strong>
        {user.forename} {user.surname}
      </strong>{' '}
      created successfully!
    </Alert>
  ) : null
}
